export default function CommentsIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        fill="#59A7FF"
        d="M10.226 2.518C9.096 1.64 7.594 1.157 6 1.157c-.145 0-.29.004-.434.012-1.431.08-2.765.551-3.792 1.349C.63 3.406 0 4.59 0 5.853c0 1.14.522 2.23 1.474 3.085-.28.652-.639 1.19-1.067 1.602a.176.176 0 00.117.303h.042c.248 0 1.52-.035 2.927-.722A7.286 7.286 0 006 10.55c1.594 0 3.095-.483 4.226-1.36C11.37 8.3 12 7.115 12 5.852s-.63-2.447-1.774-3.335z"
      />
      <path
        fill="#fff"
        d="M9.336 6a.88.88 0 01-1.17.829.88.88 0 01.292-1.708.88.88 0 01.878.879z"
      />
      <path
        fill="#DCECF4"
        d="M9.335 6a.88.88 0 01-1.17.829.88.88 0 000-1.658.88.88 0 011.17.829z"
      />
      <path
        fill="#fff"
        d="M4.42 6a.88.88 0 01-1.17.829.88.88 0 01.292-1.708A.88.88 0 014.42 6z"
      />
      <path
        fill="#DCECF4"
        d="M4.42 6a.88.88 0 01-1.171.829.88.88 0 000-1.658.88.88 0 011.17.829z"
      />
      <path
        fill="#fff"
        d="M6.878 6a.88.88 0 01-1.17.829A.88.88 0 016 5.12a.88.88 0 01.878.88z"
      />
      <path
        fill="#DCECF4"
        d="M6.877 6a.88.88 0 01-1.17.829.88.88 0 000-1.658.88.88 0 011.17.829z"
      />
      <path
        fill="#3A83D6"
        d="M12 5.853c0 1.263-.63 2.447-1.774 3.335-1.13.878-2.631 1.361-4.226 1.361a7.9 7.9 0 01-.434-.012c1.432-.08 2.766-.551 3.793-1.349 1.144-.888 1.774-2.072 1.774-3.335s-.63-2.447-1.774-3.335C8.332 1.72 7 1.248 5.567 1.168c.143-.007.288-.011.433-.011 1.595 0 3.096.483 4.226 1.36C11.37 3.407 12 4.59 12 5.854z"
      />
    </svg>
  );
}
